import styled from "styled-components";

export const NoSignalContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4198b9;
  /* background: #181d20; */
  background-color: #181d20;

  box-shadow: inset 0 0 35px 10px #4b585d;
`;
export const NoSignalBox = styled.div`
  height: 667px;
  width: 315px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
export const NoSignalContent = styled.div`
  /* font-size: 30px; */
  font-size: ${(p) => (p.reload ? "20px" : "36px")};
  text-align: center;
  /* text-transform: ${(p) => (p.reload ? "unset" : "uppercase")}; */
  margin-bottom: 50%;
  /* @media only screen and (min-width: 365px) {
    font-size: 36px;
  } */
  p {
    text-transform: none;
  }
`;
export const NoSignalBtn = styled.div`
  /* height: 48px; */
  font-size: 20px;
  height: 56px;
  max-width: 315px;
  border-radius: 38px;
  width: 100%;
  /* max-width: 260px; */
  /* font-size: 18px; */
  padding: 0 15px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  /* position: absolute; */
  /* bottom: 38px; */
  border: solid 3px #4198b9;

  /* @media only screen and (min-width: 375px) {
    font-size: 20px;
    height: 56px;
    max-width: 315px;
  } */
`;
export const OPWrapper = styled.div`
  /* background: green; */
  /* padding-bottom: 30px; */
  @media screen and (min-height: 100px) {
    transform: scale(0.14);
  }
  @media screen and (min-height: 200px) {
    transform: scale(0.3);
  }
  @media screen and (min-height: 250px) {
    transform: scale(0.38);
  }
  @media screen and (min-height: 300px) {
    transform: scale(0.45);
  }
  @media screen and (min-height: 350px) {
    transform: scale(0.5);
  }
  @media screen and (min-height: 400px) {
    transform: scale(0.6);
  }
  @media screen and (min-height: 450px) {
    transform: scale(0.7);
  }
  @media screen and (min-height: 500px) {
    transform: scale(0.75);
  }
  @media screen and (min-height: 550px) {
    transform: scale(0.8);
  }
  @media screen and (min-height: 600px) {
    transform: scale(0.9);
  }
  @media screen and (min-height: 667px) {
    transform: scale(1);
  }
`;

// import styled from "styled-components";

// export const Signal = styled.div`
//   background-color: #181d20;
//   box-shadow: inset 0 0 70px 20px #3d538f;
//   position: absolute;
//   top: 0;
//   left: 0;
//   align-items: center;
//   opacity: 0.91;
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   padding: 20px 8% 8%;
//   animation: shadow 2.5s ease-in-out infinite forwards;
//   -webkit-animation: shadow 2.5s ease-in-out infinite forwards;
//   -ms-animation: shadow 2.5s ease-in-out infinite forwards;
//   -o-animation: shadow 2.5s ease-in-out infinite forwards;
//   @keyframes shadow {
//     0% {
//       box-shadow: inset 0 0 70px 20px #3d538f;
//     }
//     50% {
//       box-shadow: inset 0 0 70px 50px #3d538f;
//     }
//     100% {
//       box-shadow: inset 0 0 70px 20px #3d538f;
//     }
//   }
//   @-webkit-keyframes shadow {
//     0% {
//       box-shadow: inset 0 0 70px 20px #3d538f;
//     }
//     50% {
//       box-shadow: inset 0 0 70px 30px #3d538f;
//     }
//     100% {
//       box-shadow: inset 0 0 70px 20px #3d538f;
//     }
//   }
// `;
// export const Title = styled.div`
//   color: #80a6f4;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   flex-direction: column;
//   font-size: 36px;
//   font-weight: bold;
//   font-style: normal;
//   font-stretch: expanded;
//   line-height: normal;
//   letter-spacing: normal;
//   text-align: center;
//   max-width: 320px;
//   height: 80%;
// `;
// export const Connect = styled.div`
//   color: #86adf6;
//   border: solid 3px #86adf6;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   font-size: 20px;
//   border-radius: 30px;
//   max-width: 320px;
//   width: 100%;
//   padding: 16px 84px;
//   cursor: pointer;
// `;
